export class HotMarket {
    _id: string;
    name: string;
    deleted: boolean;
    city: string;
    state: string;
    zip: string;
    description: string;
    location: {
        lat: number;
        lng: number;
    };
    featured: boolean;
    photos: any; // Array of GooglePhotos
    attractions: any; // Virtual
    createdAt: Date;
    updatedAt: Date;

    hasSearchTerms; // For filters
    dateCreatedRange; // For filters
    dateCreated; // For filters
    dateCreatedEnd; // For filters
    jobs; // auto populated
}